export enum FormFieldNames {
  ORGANIZATION_NAME = 'organizationName',
  ORGANIZATIONAL_BOUNDARY = 'organizationalBoundary',
  ORGANIZATION_SIZE = 'organizationSize',
  SECTOR = 'sector',
  COMPANY_TYPE = 'companyType',
}

export enum FormFieldLabels {
  ORGANIZATION_NAME = 'Organization Name',
  ORGANIZATIONAL_BOUNDARY = 'Organizational Boundary',
  ORGANIZATION_SIZE = 'Organization Size',
  SECTOR = 'Sector',
  COMPANY_TYPE = 'Company Type',
}

export enum FormFieldPlaceholders {
  ORGANIZATION_NAME = 'Enter Organization Name',
  ORGANIZATIONAL_BOUNDARY = 'Select Organizational Boundary',
  ORGANIZATION_SIZE = 'Select Organization Size',
  SECTOR = 'Select Sector',
  COMPANY_TYPE = 'Select Company Type',
}
